import { useEffect, useState, useRef } from 'react';
import { config } from '../util/config';

const usePageDetails = title => {
  const [result, setResult] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const cacheRef = useRef({});

  useEffect(() => {
    if (title in cacheRef.current) {
      setLoading(false);
      setResult(cacheRef.current[title]);
      return;
    }

    setResult(undefined);

    if (title) {
      setLoading(true);

      const params = new URLSearchParams({
        'action': 'parse',
        'format': 'json',
        'page': title.replaceAll('_', ' '),
        'prop': 'properties',
        'formatversion': 2,
        'redirects': 1,
        'origin': '*',
      })

      fetch(config.WIKI_API_URL + '?' + params)
        .then(res => res.json())
        .then(data => {
          const r = data.parse;
          if (!r) {
            const fallback = { id: null, title, description: null, redirect: undefined };
            setResult(fallback);
            cacheRef.current = { ...cacheRef.current, [title]: fallback };
            setLoading(false);
            return;
          }
          const parsed = {
            id: r.pageid,
            title: r.title,
            description: r.properties?.['wikibase-shortdesc'],
            redirect: (r.redirects?.length > 0) ? r.redirects[0] : undefined,
          };
          setResult(parsed);
          cacheRef.current = { ...cacheRef.current, [title]: parsed };
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching wiki page details', err);
          setLoading(false);
        })
    }
    else {
      setLoading(false);
    }
  }, [title]);

  return [result, loading];
}

export default usePageDetails;
